import { DateTime } from 'luxon';
import { _DurationUnits } from '@/hooks/use-notifications';

/**
 * It takes two dates and returns the difference between them in the specified unit
 * @param {DateTime} start - DateTime - The start date
 * @param {DateTime} end - DateTime - The end date
 * @param {_DurationUnits} [type] - _DurationUnits
 * @returns A number
 */
export function getDiffBetweenDates(
  start: DateTime,
  end: DateTime,
  type?: _DurationUnits
): number {
  const diff = start.diff(end, type).toObject();
  return Number(diff[`${type}s`]?.toFixed(0));
}
